import {
    SET_JOB_TITLE_GRID_DATA,
    SET_JOB_TITLE_EXCEL_DATA,
    IS_JOB_TITLE_SAVED,
    SET_EDIT_JOB_TITLE_DATA_BY_ID,
    SET_SAVE_MULTIPLE_JOB_TITLE_STATUS
} from "./JobTitleType";

const initialState = {
    jobTitleGridData: {},
    jobTitleExcelData: {},
    isJobTitleSaved: null,
    editJobTitleDataById: {},
    isSavedMultipleJobTitleStatus: null
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_JOB_TITLE_GRID_DATA:
            return {
                ...state,
                jobTitleGridData: action.jobTitleGridData,
            };
        case SET_JOB_TITLE_EXCEL_DATA:
            return {
                ...state,
                jobTitleExcelData: action.jobTitleExcelData,
            };
        case IS_JOB_TITLE_SAVED:
            return {
                ...state,
                isJobTitleSaved: action.isJobTitleSaved,
            }
        case SET_EDIT_JOB_TITLE_DATA_BY_ID:
            return {
                ...state,
                editJobTitleDataById: action.editJobTitleDataById,
            };
        case SET_SAVE_MULTIPLE_JOB_TITLE_STATUS:
            return {
                ...state,
                isSavedMultipleJobTitleStatus: action.isSavedMultipleJobTitleStatus,
            };
        default:
            return state;
    }
};

export default reducer;